<template>
  <div class="svga-box">
    <div ref="drawContainer" class="drawBtn"></div>
  </div>
</template>

<script>
import SVGA from 'svgaplayerweb';

export default {
  data() {
    return {
      player: null,
      parser: null,
      giftQueue: [],
      isPlaying: false,
      playLock: false,
      currentFrame: 0,
      totalFrames: 0,
      frameTimer: null,
      playTimeout: null // 独立的播放超时定时器
    };
  },
  mounted() {
    this.initSVGA();
  },
  beforeUnmount() {
    this.destroySVGA();
  },
  methods: {
    initSVGA() {
      if (this.player) return;

      try {
        const container = this.$refs.drawContainer;
        if (!container) {
          console.error('SVGA 容器不存在');
          return;
        }

        this.player = new SVGA.Player(container);
        this.player.loops = 1; // 播放1次，核心！之前设0可能导致异常
        this.player.clearsAfterStop = true;
        this.player.fillMode = "forwards";

        // 原生事件作为兜底
        this.player.onFinished = () => {
          console.log('原生onFinished事件触发');
          this.stopCurrentPlay();
          this.resetPlayState();
          this.playNextGift();
        };

        this.parser = new SVGA.Parser();
        console.log('SVGA 初始化完成');
      } catch (error) {
        console.error('SVGA 初始化失败：', error);
      }
    },

    // 添加礼物到队列
    addGiftToQueue(svgaUrl) {
      if (!svgaUrl) return;

      // 去重
      const isExisted = this.giftQueue.some(url => url === svgaUrl);
      if (isExisted) return;

      this.giftQueue.push(svgaUrl);
      console.log('添加礼物到队列：' + svgaUrl + '，队列长度：' + this.giftQueue.length);

      // 立即尝试播放（无需等nextTick，避免队列堆积）
      this.playNextGift();
    },

    playNextGift() {
      // 仅保留核心锁校验，避免过度校验导致无法播放
      if (this.playLock || this.giftQueue.length === 0) {
        console.log('播放条件不满足：锁=' + this.playLock + '，队列长度=' + this.giftQueue.length);
        return;
      }

      // 加锁
      this.playLock = true;
      this.isPlaying = true;

      const currentGiftUrl = this.giftQueue.shift();
      console.log('开始播放礼物：', currentGiftUrl);

      this.parser.load(
        currentGiftUrl,
        (videoItem) => {
          if (!videoItem) {
            console.error('解析失败：', currentGiftUrl);
            this.resetPlayState();
            this.playNextGift();
            return;
          }

          try {
            // 播放前强制清理所有残留定时器和状态
            this.stopCurrentPlay();
            
            this.totalFrames = videoItem.frames || 0;
            this.currentFrame = 0;

            // 核心：使用视频本身的帧率计算间隔，而非固定40ms
            const frameInterval = 1000 / (videoItem.fps || 24); // 按实际帧率计算间隔
            
            // 重置播放器并播放
            this.player.stopAnimation();
            this.player.clear();
            this.player.setVideoItem(videoItem);
            this.player.startAnimation();
            console.log(`开始播放，总帧数：${this.totalFrames}，帧率：${videoItem.fps || 24}，间隔：${frameInterval}ms`);

            // 帧监听：按实际帧率计时
            this.frameTimer = setInterval(() => {
              this.currentFrame++;
              console.log(`当前帧：${this.currentFrame}/${this.totalFrames}`);
              
              // 到达最后一帧（留1帧缓冲，避免提前停止）
              if (this.currentFrame >= this.totalFrames - 1) {
                this.stopCurrentPlay();
                this.resetPlayState();
                this.playNextGift();
              }
            }, frameInterval);

            // 超时保护：总帧数*帧间隔 + 1秒缓冲
            this.playTimeout = setTimeout(() => {
              console.warn('播放超时，强制停止');
              this.stopCurrentPlay();
              this.resetPlayState();
              this.playNextGift();
            }, (this.totalFrames * frameInterval) + 1000);

          } catch (playError) {
            console.error('播放礼物时出错：', playError);
            this.stopCurrentPlay();
            this.resetPlayState();
            this.playNextGift();
          }

        },
        (error) => {
          console.error('加载失败：', error);
          this.resetPlayState();
          this.playNextGift();
        }
      );
    },

    // 安全停止当前播放（统一管理定时器和播放器）
    stopCurrentPlay() {
      try {
        // 清理所有定时器
        clearInterval(this.frameTimer);
        clearTimeout(this.playTimeout);
        this.frameTimer = null;
        this.playTimeout = null;

        // 停止播放器
        if (this.player) {
          this.player.stopAnimation();
          this.player.clear();
        }

        // 重置帧计数
        this.currentFrame = 0;
        this.totalFrames = 0;
        console.log('当前播放已停止并清理');
      } catch (stopError) {
        console.error('停止播放时出错：', stopError);
      }
    },

    // 重置状态锁
    resetPlayState() {
      this.isPlaying = false;
      this.playLock = false;
      console.log('播放状态已重置');
    },

    clearGiftQueue() {
      this.giftQueue = [];
      this.stopCurrentPlay();
      this.resetPlayState();
    },

    // 安全销毁资源
    destroySVGA() {
      try {
        this.stopCurrentPlay();
        
        if (this.player) {
          this.player.onFinished = null; // 移除事件监听
          this.player = null;
        }
        
        this.parser = null;
        this.giftQueue = [];
        this.resetPlayState();
      } catch (destroyError) {
        console.error('销毁SVGA时出错：', destroyError);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "./playSvga.css";
</style>


// WEBPACK FOOTER //
// playSvga.vue?ce5d4c20